import Button from "@mui/material/Button";
import { Dialog } from "../../../components/Dialog";
import WinnersIcon from "../../../assets/campaign/winners.png";
import EmptyWinnersIcon from "../../../assets/campaign/empty-winners.png";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import ReactCardFlip from "react-card-flip";
import { useStyles } from "../styles";
import { useEffect, useRef, useState } from "react";

type Awarded = { id: number; nome: string; documento: string; view?: boolean };

type PeopleAwardedProps = {
  awarded: Awarded[];
  open: boolean;
  onClose: () => void;
};

const emojis = {
  0: "🥇",
  1: "🥈",
  2: "🥉",
};

// Create your forceUpdate hook
function useForceUpdate() {
  let [value, setState] = useState(true);
  return () => setState(!value);
}

export function PeopleAwarded({ onClose, open, awarded }: PeopleAwardedProps) {
  const dialogRef = useRef<HTMLInputElement>(null);
  const styles = useStyles();
  const handleForceupdateMethod = useForceUpdate();
  const [newAwarded, setNewAwarded] = useState<Awarded[]>();

  useEffect(() => {
    if (Array.isArray(awarded)) {
      const listAwarded = awarded?.map((award) => ({ ...award, view: false }));
      setNewAwarded(listAwarded);
    }
  }, [awarded]);

  const handleViewAwarded = (index: number) => {
    setNewAwarded((prev) => {
      prev[index] = { ...prev[index], view: true };
      return prev;
    });
    handleForceupdateMethod();
  };

  return (
    <Dialog ref={dialogRef} fullWidth maxWidth="sm" open={open}>
      <Stack spacing={2} alignItems="center" paddingX={2}>
        {newAwarded?.length > 0 ? (
          <>
            <img alt="prize-draw" style={{ width: "50%" }} src={WinnersIcon} />
            <Typography variant="body2">Parabéns ao vencedores! 🏆 </Typography>
            <Stack spacing={1} alignItems="center" width="100%">
              {newAwarded?.map((award, index) => (
                <ReactCardFlip
                  key={index.toString()}
                  isFlipped={award.view}
                  flipDirection="vertical"
                  containerStyle={{ width: "100%" }}
                >
                  <Paper
                    variant="outlined"
                    elevation={0}
                    className={styles.paper}
                  >
                    <Stack
                      alignItems="center"
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Typography variant="body1" color="primary">
                        {index + 1}º lugar {emojis[index]}
                      </Typography>

                      <Button
                        onClick={() => {
                          handleViewAwarded(index);
                        }}
                        color="inherit"
                        size="small"
                      >
                        Anunciar
                      </Button>
                    </Stack>
                  </Paper>

                  <Paper
                    variant="outlined"
                    elevation={0}
                    className={styles.paper}
                  >
                    <Stack
                      alignItems="center"
                      direction="row"
                      justifyContent="space-between"
                    >
                      <Typography variant="body1">
                        {award.nome?.toUpperCase()} {emojis[index]}
                      </Typography>
                    </Stack>
                  </Paper>
                </ReactCardFlip>
              ))}
            </Stack>
          </>
        ) : (
          <>
            <img
              alt="prize-draw"
              style={{ width: "50%" }}
              src={EmptyWinnersIcon}
            />
            <Typography variant="body2" align="center">
              Não foi encontrado nenhum participante nesse sorteio.
            </Typography>
            <Typography variant="body2" align="center">
              Por segurança, vamos encerrar a premiaçâo e disponibilizar o vídeo
              do sorteio.
            </Typography>
          </>
        )}

        <Button onClick={onClose} variant="contained" fullWidth color="primary">
          Ok
        </Button>
      </Stack>
    </Dialog>
  );
}
